import { Card, Table, Select, Button, Space, Form } from "antd";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";
import { useNavigate } from "react-router-dom";

function ClientPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [clientfilterdata, setclientfilterData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },

    { title: "clientName", dataIndex: "clientName" },
    { title: "Email", dataIndex: "clientEmail" },
    { title: "Address", dataIndex: "clientAddress" },
    { title: "Phone Number", dataIndex: "clientPhoneNumber" },
    { title: "Alt Phone", dataIndex: "clientAltphone" },
    { title: "Username", dataIndex: "clientUsername" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: boolean) => (
        <span style={{ color: status ? "green" : "red" }}>
          {status ? "Enabled" : "Disabled"}
        </span>
      ),
    },

    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() =>
              navigate(`/Admin/clientdata/updatedstatus/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const fetchClientdata = async (
    currentPage: number,
    currentPageSize: number
  ) => {
    try {
      setIsLoading(true);
      const obj = { query: "query", page: currentPage, take: currentPageSize };
      const url = API.LISTING_CLIENT_DATA;
      const response: any = await POST(url, obj);

      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClientdata(page, pageSize);
  }, [page, pageSize]);

  const filterClientData = async (values: any) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_CLIENT_DATA;
      const response: any = await POST(api, values);

      if (response?.data) {
        setclientfilterData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-12">
            <h2 className="text-center mb-4">Partners Details</h2>
            <Card className="mb-4">
              <Form
                form={form}
                layout="inline"
                onFinish={filterClientData}
                style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
              >
                <Form.Item name="clientName">
                  <Select
                    placeholder="Select Client Name"
                    allowClear
                    style={{ width: "200px" }}
                    options={data.map((item: any) => ({
                      value: item.clientName,
                      label: item.clientName,
                    }))}
                  />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Filter
                  </Button>
                  <Button
                    style={{ marginLeft: 8 }}
                    onClick={() => {
                      form.resetFields();
                      setclientfilterData([]); // Clear filtered data
                      fetchClientdata(page, pageSize);
                    }}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </Form>
            </Card>
            <Card>
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={clientfilterdata.length ? clientfilterdata : data}
                  loading={isLoading}
                  pagination={{
                    current: page,
                    pageSize: pageSize,
                    total: meta?.total,
                    showSizeChanger: true,
                    onChange: (currentPage: number, currentSize: number) => {
                      setPage(currentPage);
                      setPageSize(currentSize);
                    },
                  }}
                  rowKey={(record: any) => record.id || record.clientUsername}
                  scroll={{ x: "max-content" }}
                />
              </div>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClientPage;
